<template>
    <div class="menu" :style="{paddingLeft:collapsed?collapsedWidth+'px':expandWidth+'px'}">
      <!--导航栏菜单 -->
      <slot-menu #menu="menu">
        <admin-menu-list :children="menu.items"/>
      </slot-menu>
    </div>
</template>
<script setup>

import initialize from "@/layouts/admin-sidebar/initialize";

let {
  collapsed,
  collapsedWidth,
  expandWidth,
} = initialize();


</script>
<style scoped lang="scss">
.menu {
  padding-left: 1.5rem;
  @include flex-center;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 21, 41, 0.12) !important;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 4px 4px 0 0;
}
</style>
